module.exports = __webpack_public_path__ + "img/shipo-menu-vessel-line-up.4313f042.svg";